import { calculateSpeed, GhostAI } from './GhostAI';
import Ghost from '../Ghost';
import { tileSize } from '~/src/consts/sizes';
export default class RespawnAI implements GhostAI {
	private readonly ghost: Ghost;

	get disallowLastMoveTime() {
		return 800;
	}

	get speed() {
		return (calculateSpeed(this.ghost.level - 1) + 4) * tileSize;
	}

	get targetPosition() {
		return {
			x: 448,
			y: 480
		};
	}

	constructor(ghost: Ghost) {
		this.ghost = ghost;
	}

	chooseTarget() {
		const { x, y } = this.ghost;
		const { x: tx, y: ty } = this.targetPosition;

		if (Phaser.Geom.Rectangle.Contains(Phaser.Geom.Rectangle.FromPoints([
			{ x: tx, y: ty },
			{ x: tx + 64, y: ty + 64 }
		]), x, y)) {
			this.ghost.setPosition(tx, 528);
			this.ghost.respawn();
		}
	}
}
